import intl from 'react-intl-universal'

export default [
  {
    icon: 'fa-bold',
    tooltip: intl.get('keyBindings.items.bold'),
    action: 'bold',
    flag: 1,
    keyBinding: ['ctrl+b', 'cmd+b'],
  },
  {
    icon: 'fa-italic',
    tooltip: intl.get('keyBindings.items.italic'),
    action: 'italic',
    flag: 2,
    keyBinding: ['ctrl+i', 'cmd+i'],
  },
  {
    icon: 'fa-underline',
    tooltip: intl.get('keyBindings.items.underline'),
    action: 'underline',
    flag: 4,
    keyBinding: ['ctrl+u', 'cmd+u'],
  },
  {
    icon: 'fa-link',
    tooltip: intl.get('typographyButtons.insertHyperlinkTooltip'),
    action: 'createLink',
    flag: 8,
  },
  {
    icon: 'fa-times',
    tooltip: intl.get('keyBindings.items.removeTextFormatting'),
    action: 'removeFormat,unlink',
  },
  {
    unicode: '&Omega;',
    tooltip: `${intl.get(
      'ActionsToolbar.tooltips.specialChar'
    )} (ctrl+k or cmd+k)`,
    action: 'charmap',
    keyBinding: ['ctrl+k', 'cmd+k'],
  },
  {
    unicode: '&#128172;',
    tooltip: `${intl.get(
      'keyBindings.items.inlineComment'
    )} (ctrl+alt+n or ctrl+/)`,
    action: 'inlineComment',
    flag: 32,
    keyBinding: [
      'ctrl+/',
      'cmd+/',
      'ctrl+alt+n',
      'cmd+alt+Dead',
      'ctrl+alt+Dead',
    ],
  },
]
